import { render, staticRenderFns } from "./itemReposMedical.vue?vue&type=template&id=771327ec&"
import script from "./itemReposMedical.vue?vue&type=script&lang=js&"
export * from "./itemReposMedical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports